"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Portal = _interopRequireDefault(require("./Portal"));

var _position = require("./position");

var _hooks = require("./hooks");

var _Elements = require("./Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Popover(props) {
  var initVisible = props.initVisible,
      content = props.content,
      directions = props.directions,
      children = props.children,
      callback = props.callback,
      closeFuncCallback = props.closeFuncCallback,
      constDomStyle = props.constDomStyle,
      modalDomStyle = props.modalDomStyle,
      triangleDomStyle = props.triangleDomStyle,
      innerDomStyle = props.innerDomStyle,
      innerConstDomStyle = props.innerConstDomStyle,
      modalRefCallback = props.modalRefCallback,
      needOutsideClose = props.needOutsideClose,
      needOutsideCloseCallback = props.needOutsideCloseCallback,
      forceValue = props.forceValue,
      disabled = props.disabled;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      style = _useState4[0],
      setStyle = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      triaStyle = _useState6[0],
      setTriaStyle = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      forceState = _useState8[0],
      forceRender = _useState8[1];

  var modalRef = (0, _react.useRef)(null);
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (callback) {
      callback(function () {
        return forceRender(function (v) {
          return v + 1;
        });
      });
    }
  }, [callback]);
  (0, _react.useEffect)(function () {
    if (forceValue && initVisible) {
      setVisible(initVisible);
    }
  }, [initVisible, forceValue]); // 这里是常驻的dom

  var constDom = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: _objectSpread({
        display: 'inline-block'
      }, constDomStyle),
      ref: ref
    }, children);
  }, [children, constDomStyle]); // 提供样式并定位

  var finalRender = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Elements.FinalRender, {
      style: _objectSpread(_objectSpread({}, style), modalDomStyle),
      ref: modalRef
    }, content);
  }, [style, modalDomStyle, content]); // 1个render需要一个小三角

  var triangle = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Elements.Triangle, {
      style: _objectSpread(_objectSpread({}, triaStyle), triangleDomStyle)
    });
  }, [triaStyle, triangleDomStyle]);
  (0, _react.useEffect)(function () {
    // 出现时才有modal
    if (ref.current && modalRef.current) {
      var scroll = document.documentElement.scrollTop + document.body.scrollTop; // 移动端可能取不到

      var res = (0, _position.switchPosition)(directions, modalRef.current.getBoundingClientRect(), ref.current.getBoundingClientRect(), scroll);
      setStyle(res); // 拿到三角形的pos

      var res2 = (0, _position.switchTrianglePosition)(directions, modalRef.current.getBoundingClientRect(), ref.current.getBoundingClientRect(), scroll);
      setTriaStyle(res2);
    }
  }, [directions, modalRef, visible, forceState, forceValue]);
  (0, _react.useEffect)(function () {
    var handler = function handler() {
      forceRender(function (prev) {
        return prev + 1;
      });
    };

    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, [forceRender]);
  (0, _react.useEffect)(function () {
    if (modalRefCallback) {
      modalRefCallback(modalRef);
    }
  }, [modalRefCallback]);

  var _useStateAnimation = (0, _hooks.useStateAnimation)(setVisible, 150),
      _useStateAnimation2 = (0, _slicedToArray2["default"])(_useStateAnimation, 3),
      state = _useStateAnimation2[0],
      setState = _useStateAnimation2[1],
      unmount = _useStateAnimation2[2];

  (0, _react.useEffect)(function () {
    var listener;

    if (needOutsideClose) {
      listener = function listener(event) {
        if (!modalRef.current || modalRef.current.contains(event.target)) {
          return;
        }

        setState(false);
        needOutsideCloseCallback();
      };

      window.addEventListener('click', listener);
    }

    return function () {
      window.removeEventListener('click', listener);
    };
  }, [needOutsideClose, setState]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Portal["default"], {
    visible: visible,
    setVisible: setVisible,
    constnode: constDom,
    closeFuncCallback: closeFuncCallback,
    innerDomStyle: innerDomStyle,
    innerConstDomStyle: innerConstDomStyle,
    state: state,
    setState: setState,
    unmount: unmount,
    disabled: disabled
  }, finalRender, triangle));
}

Popover.defaultProps = {
  initVisible: false,
  triangleDomStyle: {},
  needOutsideClose: false,
  forceValue: 0,
  disabled: false,
  constDomStyle: {},
  modalDomStyle: {},
  innerDomStyle: {},
  innerConstDomStyle: {},
  needOutsideCloseCallback: function needOutsideCloseCallback() {},
  callback: function callback() {},
  closeFuncCallback: function closeFuncCallback() {},
  modalRefCallback: function modalRefCallback() {}
};
Popover.propTypes = {
  initVisible: _propTypes["default"].bool,
  content: _propTypes["default"].node.isRequired,
  directions: _propTypes["default"].oneOf(['TL', 'TOP', 'TR', 'LT', 'LEFT', 'LB', 'BL', 'BOTTOM', 'BR', 'RT', 'RIGHT', 'RB']).isRequired,
  children: _propTypes["default"].node.isRequired,
  callback: _propTypes["default"].func,
  closeFuncCallback: _propTypes["default"].func,
  constDomStyle: _propTypes["default"].shape({}),
  modalDomStyle: _propTypes["default"].shape({}),
  triangleDomStyle: _propTypes["default"].shape({}),
  innerDomStyle: _propTypes["default"].shape({}),
  innerConstDomStyle: _propTypes["default"].shape({}),
  modalRefCallback: _propTypes["default"].func,
  needOutsideClose: _propTypes["default"].bool,
  needOutsideCloseCallback: _propTypes["default"].func,
  forceValue: _propTypes["default"].number,
  disabled: _propTypes["default"].bool
};
var _default = Popover;
exports["default"] = _default;